<div style="height: 550px;">
  <form [formGroup]="SettingsForm">
    <div class="col-lg-12 schedule-section">
      <fieldset>
        <legend>Minutes</legend>
        <div class="schedule-section-content">
          <input type="radio" name="schedType" value="2" [checked]="SchedTypeEquals('2')" [formControl]="ScheduleType"
            (change)="enableDisableControls()" />
          <span class="uv-checkbox-label">Every</span>
          <input type="number" pInputText class="schedule-control" style="width: 80px;" [formControl]="Minutes_Interval"
            [ngClass]="{'show-error':SettingsForm.hasError('minutes_interval_valid')}" />
          <span class="schedule-control">minutes</span>
          @if (SettingsForm.hasError('minutes_interval_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
          @if (SettingsForm.hasError('minutes_interval_minValue') || SettingsForm.hasError('minutes_interval_maxValue'))
          {
          <div class="alert alert-danger">This value must be in the range 1 - 999</div>
          }
        </div>
      </fieldset>
    </div>
    <div class="col-lg-12 schedule-section">
      <fieldset>
        <legend>Hours</legend>
        <div class="schedule-section-content">
          <input type="radio" name="schedType" value="3" [checked]="SchedTypeEquals('3')" [formControl]="ScheduleType"
            (change)="enableDisableControls()" />
          <span class="uv-checkbox-label">Every</span>
          <input type="number" pInputText class="schedule-control" style="width: 80px;" [formControl]="Hours_Interval"
            [ngClass]="{'show-error':SettingsForm.hasError('hours_interval_valid')}" />
          <span class="schedule-control">hours at</span>
          <input type="number" pInputText class="schedule-control" style="width: 80px;" [formControl]="Hours_AfterHour"
            [ngClass]="{'show-error':SettingsForm.hasError('hours_after_hour_valid')}" />
          <span class="schedule-control">minutes after the hour</span>
          @if (SettingsForm.hasError('hours_interval_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
          @if (SettingsForm.hasError('hours_interval_minValue') || SettingsForm.hasError('hours_interval_maxValue')) {
          <div class="alert alert-danger">This value must be in the range 1 - 999</div>
          }
          @if (SettingsForm.hasError('hours_after_hour_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
          @if (SettingsForm.hasError('hours_after_hour_minValue') || SettingsForm.hasError('hours_after_hour_maxValue'))
          {
          <div class="alert alert-danger">This value must be in the range 0 - 59</div>
          }
        </div>
      </fieldset>
    </div>
    <div class="col-lg-12 schedule-section">
      <fieldset>
        <legend>Days</legend>
        <div class="schedule-section-content">
          <input type="radio" name="schedType" value="4" [checked]="SchedTypeEquals('4')" [formControl]="ScheduleType"
            (change)="enableDisableControls()" />
          <span class="uv-checkbox-label">Every</span>
          <input type="number" pInputText class="schedule-control" style="width: 80px;" [formControl]="Days_Interval"
            [ngClass]="{'show-error':SettingsForm.hasError('days_interval_valid')}" />
          <span class="schedule-control">days starting at</span>
          <p-calendar formControlName="Days_Time" timeOnly="true" hourFormat="12"
            [ngClass]="{'show-error':SettingsForm.hasError('days_time_valid')}"
            [disabled]="!SchedTypeEquals('4')"></p-calendar>

          @if (SettingsForm.hasError('days_interval_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
          @if (SettingsForm.hasError('days_interval_minValue') || SettingsForm.hasError('days_interval_maxValue')) {
          <div class="alert alert-danger">This value must be in the range 1 - 999</div>
          }
          @if (SettingsForm.hasError('days_time_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
        </div>
      </fieldset>
    </div>
    <div class="col-lg-12 schedule-section">
      <fieldset>
        <legend>Weekly</legend>
        <div class="schedule-section-content">
          <input type="radio" name="schedType" value="5" [checked]="SchedTypeEquals('5')" [formControl]="ScheduleType"
            (change)="enableDisableControls()" />
          <span class="uv-checkbox-label">Every</span>
          <p-multiSelect styleClass="schedule-control weekly-days-of-week" [options]="DaysOfWeek_Values"
            formControlName="Weekly_DaysOfWeek"
            [ngClass]="{'show-error':SettingsForm.hasError('weekly_days_of_week_valid')}"
            [disabled]="!SchedTypeEquals('5')"></p-multiSelect>
          <span class="schedule-control">starting at</span>
          <p-calendar formControlName="Weekly_Time" timeOnly="true" hourFormat="12"
            [ngClass]="{'show-error':SettingsForm.hasError('weekly_time_valid')}"
            [disabled]="!SchedTypeEquals('5')"></p-calendar>
          @if (SettingsForm.hasError('weekly_days_of_week_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
          @if (SettingsForm.hasError('weekly_time_notEmpty')) {
          <div class="alert alert-danger">This value is required</div>
          }
        </div>
      </fieldset>
    </div>
    <div class="col-lg-12 schedule-section">
      <fieldset>
        <legend>Monthly</legend>
        <div class="schedule-section-content">
          <div>
            <input type="radio" name="schedType" value="6" [checked]="SchedTypeEquals('6')" [formControl]="ScheduleType"
              (change)="enableDisableControls()" />
            <span class="uv-checkbox-label">The</span>
            <select class="schedule-control" style="width: auto;" [formControl]="Monthly_DayOfMonth">
              <option value="1">1st</option>
              <option value="2">2nd</option>
              <option value="3">3rd</option>
              <option value="4">4th</option>
              <option value="5">5th</option>
              <option value="6">6th</option>
              <option value="7">7th</option>
              <option value="8">8th</option>
              <option value="9">9th</option>
              <option value="10">10th</option>
              <option value="11">11th</option>
              <option value="12">12th</option>
              <option value="13">13th</option>
              <option value="14">14th</option>
              <option value="15">15th</option>
              <option value="16">16th</option>
              <option value="17">17th</option>
              <option value="18">18th</option>
              <option value="19">19th</option>
              <option value="20">20th</option>
              <option value="21">21st</option>
              <option value="22">22nd</option>
              <option value="23">23rd</option>
              <option value="24">24th</option>
              <option value="25">25th</option>
              <option value="26">26th</option>
              <option value="27">27th</option>
              <option value="28">28th</option>
              <option value="29">29th</option>
              <option value="30">30th</option>
              <option value="31">31st</option>
              <option value="0">Last</option>
            </select>
            <span class="schedule-control">day of each month starting at</span>
            <p-calendar formControlName="Monthly_Time1" timeOnly="true" hourFormat="12"
              [ngClass]="{'show-error':SettingsForm.hasError('monthly_time_1_valid')}"
              [disabled]="!SchedTypeEquals('6')"></p-calendar>
            @if (SettingsForm.hasError('monthly_time_1_notEmpty')) {
            <div class="alert alert-danger">This value is required</div>
            }
          </div>
          <br />
          <div>
            <input type="radio" name="schedType" value="7" [checked]="SchedTypeEquals('7')" [formControl]="ScheduleType"
              (change)="enableDisableControls()" />
            <span class="uv-checkbox-label">The</span>
            <select class="schedule-control" style="width: auto;" [formControl]="Monthly_DayOrdinal">
              <option value="0">First</option>
              <option value="1">Second</option>
              <option value="2">Third</option>
              <option value="3">Fourth</option>
              <!--<option value="4">Fifth</option>-->
              <option value="5">Last</option>
            </select>
            <select class="schedule-control" style="width: auto;" [formControl]="Monthly_DayOfWeek">
              <option value="0">Sunday</option>
              <option value="1">Monday</option>
              <option value="2">Tuesday</option>
              <option value="3">Wednesday</option>
              <option value="4">Thursday</option>
              <option value="5">Friday</option>
              <option value="6">Saturday</option>
            </select>
            <span class="schedule-control">of each month starting at</span>
            <p-calendar formControlName="Monthly_Time2" timeOnly="true" hourFormat="12"
              [ngClass]="{'show-error':SettingsForm.hasError('monthly_time_2_valid')}"
              [disabled]="!SchedTypeEquals('7')"></p-calendar>
            @if (SettingsForm.hasError('monthly_time_2_notEmpty')) {
            <div class="alert alert-danger">This value is required</div>
            }
          </div>
        </div>
      </fieldset>
    </div>
  </form>
</div>